export const IntroPanel = {
  flow: 'y',
  fontSize: 'Z1',
  padding: 'A2 A A2',
  gap: 'C',
  overflow: 'hidden auto',
  Hgroup: {
    H: {
      fontSize: 'B2',
      margin: '0',
      color: 'title',
      fontWeight: '500',
      text: (el) => {
        const { name, username } = el.getRootState()
        return el.call('polyglot', 'learn.intro.greeting').replace('{name}', username || name || '')
      }
    },
    P: {
      margin: '0',
      fontSize: 'Z2',
      color: 'paragraph',
      text: '{{ learn.intro.welcome | polyglot }}'
    }
  },
  DragParagraph: {
    fontSize: 'Z1',
    margin: 'Z auto A'
  },
  DragComponentsTutorial: {},
  Line: {
    margin: '0'
  },
  MovingOn: {
    P: {
      color: 'paragraph',
      text: '{{ learn.intro.continue | polyglot }}'
    },
    Flex: {
      flow: 'y',
      gap: 'X2',
      childExtends: 'Flex',
      childProps: {
        align: 'center',
        gap: 'Z',
        padding: 'Z2 W',
        width: '100%',
        round: 'radiusControl',
        transition: 'A defaultBezier background',
        color: 'title',
        // Row-separator-as-chrome (design-direction.md §8 / DESIGN_LANGUAGE
        // §2.5 — "no row hairlines… use gap + hover tint"). Replaced the top
        // divider with the parent Flex's `gap` and a real hover fill (§8.1)
        // instead of text-only underline.
        ':hover': {
          background: 'hover',
          textDecoration: 'underline'
        },
        Icon: {
          order: '-2',
          name: 'arrow up right'
        }
      },
      children: [
        {
          Text: {
            text: '{{ learn.intro.myContent | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.chatAi | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.moreTutorials | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.moreExamples | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.libraryComponents | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.myCode | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.documentation | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.howToExport | polyglot }}'
          }
        },
        {
          Text: {
            text: '{{ learn.intro.support | polyglot }}'
          }
        }
      ]
    }
  },
  Dismiss: {
    extends: ['CanvasButton', 'Button'],
    alignSelf: 'start',
    fontSize: 'Z',
    gap: 'X2',
    opacity: '.65',
    margin: '- - - -A',
    padding: 'Z A',
    icon: 'x circle fill',
    text: '{{ learn.intro.dismiss | polyglot }}',
    onClick: (ev, el) => {
      el.call('setCookie', 'tutorialMarked_intro', true)
      el.closeWindow('explorer')
    }
  }
}
